import { render, staticRenderFns } from "./ExpandableRow.vue?vue&type=template&id=5defffbb&"
import script from "./ExpandableRow.vue?vue&type=script&lang=js&"
export * from "./ExpandableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports